import { Mail, MapPin, Clock, Phone } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const NAV_KEYS = ["services", "whyUs", "pricing", "process", "faq", "contact", "gdpr"];
const NAV_HREFS = {
  services: "#servicii",
  whyUs: "#de-ce-noi",
  pricing: "#preturi",
  process: "#proces",
  faq: "#intrebari",
  gdpr: "#gdpr",
  contact: "#contact",
};

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-[#e2e8f0] bg-white py-14" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center pb-12">
          <img
            src="/assets/uba-logo-big.jpg"
            alt="UBA COMPANY București"
            className="h-40 w-auto sm:h-56"
            data-testid="footer-logo-big"
            loading="lazy"
          />
        </div>
      </div>
      <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#64748b]" data-testid="footer-tagline">
            {t.footer.tagline}
          </p>
        </div>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-widest text-[#0d2b52]">
            {t.footer.navTitle}
          </h3>
          <ul className="mt-4 space-y-2.5">
            {NAV_KEYS.map((key) => (
              <li key={key}>
                <a
                  href={NAV_HREFS[key]}
                  className="text-sm text-[#475569] transition-colors hover:text-[#1d6fd1]"
                  data-testid={`footer-nav-${key}`}
                >
                  {t.nav[key]}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-widest text-[#0d2b52]">
            {t.footer.contactTitle}
          </h3>
          <ul className="mt-4 space-y-3 text-sm text-[#475569]">
            <li className="flex items-center gap-2" data-testid="footer-location">
              <MapPin className="h-4 w-4 text-[#1d6fd1]" />
              {t.footer.location}
            </li>
            <li className="flex items-center gap-2" data-testid="footer-email">
              <Mail className="h-4 w-4 text-[#1d6fd1]" />
              <a
                href="mailto:uba.company1@gmail.com"
                className="transition-colors hover:text-[#1d6fd1]"
              >
                uba.company1@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-2" data-testid="footer-hours">
              <Clock className="h-4 w-4 text-[#1d6fd1]" />
              {t.whatsapp.hours}
            </li>
            <li className="flex items-center gap-2" data-testid="footer-phone">
              <Phone className="h-4 w-4 text-[#1d6fd1]" />
              <a
                href="tel:+40749994040"
                className="transition-colors hover:text-[#1d6fd1]"
              >
                {t.whatsapp.phone}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-7xl border-t border-[#e2e8f0] px-4 pt-6 sm:px-6 lg:px-8">
        <p className="text-xs text-[#94a3b8]" data-testid="footer-rights">
          © {new Date().getFullYear()} UBA COMPANY. {t.footer.rights}
        </p>
      </div>
    </footer>
  );
};
